import { useEffect } from "react";
import { useSelector } from "react-redux";
import { checkIfAdmin } from "@shared/utils/ACL";
import { useFeatureEnabledCheck } from "@shared/hooks/FeatureHook";
import { Feature, User } from "@shared/models";
import { getActiveAccount } from "@containers/Account/store/selectors";
import { authenticated } from "@containers/Auth/store/selectors";
import { useLazyGetReiSiftIntegrationSummaryQuery } from "@shared/api/reiSiftIntegrationApi";
import { getUserDetails } from "@shared/store/selectors";

export const useFetchReiSiftIntegrationSummary = () => {
  const isAuthenticated = useSelector(authenticated());
  const isIntegrationEnabled = useFeatureEnabledCheck(Feature.ReiSift);
  const account = useSelector(getActiveAccount());
  const activeUser = useSelector(getUserDetails());

  const [triggerReiSiftIntegrationSummary, response] = useLazyGetReiSiftIntegrationSummaryQuery();

  useEffect(() => {
    const isAdmin = checkIfAdmin(activeUser as User);

    const shouldFetchSummary = isAuthenticated && account?.id && isIntegrationEnabled && !isAdmin;

    if (shouldFetchSummary) {
      triggerReiSiftIntegrationSummary({ account_id: account?.id });
    }
  }, [isAuthenticated, account?.id, activeUser, isIntegrationEnabled, triggerReiSiftIntegrationSummary]);

  return response;
};
